module.exports = __webpack_public_path__ + "static/media/ca.8678fc67.svg";